import React, { useState, useEffect } from 'react';
import styles from './SubscriptionStopModal.module.css';

import { InnocodePaymentCardInfo, InnocodePaymentPasswordButton, InnocodePaymentPasswordDot } from '@intsoft/innocode-payment';
import { InnocodeButton, InnocodeDropdown } from '@intsoft/innocode-core';
import moment from 'moment';

/* 구독 일시정지 모달 */
interface SubscriptionStopModalProps {
    isOpen: boolean;
    renewalDate: number;
    onClose: () => void;
    onConfirm?: (data: any) => void;
}

export const SubscriptionStopModal: React.FC<SubscriptionStopModalProps> = (props: SubscriptionStopModalProps) => {

    const [period, setPeriod] = useState<string>('1');
    const [stopDate, setStopDate] = useState<string>('');
    const [subscriptionRenewalDateView, setSubscriptionRenewalDateView] = useState<string>('');
    const [subscriptionServiceEndDateView, setSubscriptionServiceEndDateView] = useState<string>('');
    const [subscriptionRenewalDate, setSubscriptionRenewalDate] = useState<number>(0);
    const nextPaymentDate = props.renewalDate;

    useEffect(() => {
        handleStopDateChange(period);
    }, [period]);

    const handlePeriodChange = (value: string) => {
        setPeriod(value);
    }

    const handleStopDateChange = (value: string) => {
        //renewalDate 실제 다음 결제일
        setSubscriptionServiceEndDateView(moment(nextPaymentDate).format('YYYY.MM.DD HH:mm:ss'));


        //일시정지 해제일은 현재 날짜로부터 선택한 기간만큼 이후
        const suspensionEndDate = new Date(nextPaymentDate);
        suspensionEndDate.setMonth(suspensionEndDate.getMonth() + parseInt(value));
        setStopDate(moment(suspensionEndDate).format('YYYY-MM-DD'));

        //일시정지 해제일 하루 뒤 06시로 다음 결제일 설정
        const newRenewalDate = new Date(suspensionEndDate);
        newRenewalDate.setDate(newRenewalDate.getDate() + 1);
        newRenewalDate.setHours(6);
        newRenewalDate.setMinutes(0);
        newRenewalDate.setSeconds(0);
        newRenewalDate.setMilliseconds(0);
        setSubscriptionRenewalDateView(moment(newRenewalDate).format('YYYY-MM-DD'));
        setSubscriptionRenewalDate(newRenewalDate.getTime());
    }

    const handleConfirm = () => {
        props.onConfirm?.({
            period: period,
            stopDate: stopDate,
            subscriptionRenewalDate: subscriptionRenewalDate,
        });
        props.onClose();
    }

    return (
        <div className={styles.layoutContainer}>
            <div className={styles.editorHeader}>
                <div className={styles.editorHeaderCloseButton} onClick={props.onClose}>
                    <svg className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" onClick={props.onClose} style={{ cursor: 'pointer' }}>
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                </div>
            </div>
            <div className={styles.scrollContentArea}>
                <div className={styles.minHeightArea}>
                    <div className={styles.contentAreaWrapper}>
                        <div className={styles.contentArea}>
                            <div className={styles.contentAreaTitle}>
                                <h1 className={`innocode-typography--headline-sm innocode-typography--bold ${styles.contentAreaTitleText}`}>
                                    구독을 잠시 멈춰야 한다면<br />일시정지 예약을 이용해 보세요.
                                </h1>
                                <p className={styles.contentAreaTitleDescription}>
                                    구독을 해지하지 않고 정지상태로 변경해 불필요한 지출을 줄여보세요.
                                </p>
                            </div>
                            <div className={styles.subscriptionStopPeriodWrapper}>
                                <p>기간 선택</p>
                                <InnocodeDropdown
                                    value={period}
                                    multiple={false}
                                    onChange={(value: string | string[]) => {
                                        handlePeriodChange(value as string);
                                    }}
                                    options={[{ label: '1개월', value: '1' }, { label: '3개월', value: '3' }, { label: '6개월', value: '6' }, { label: '12개월', value: '12' }]}
                                ></InnocodeDropdown>
                                <p>일시 정지 전까지 사용가능한 서비스 기간은 {subscriptionServiceEndDateView} 까지입니다.</p>
                                <p>{stopDate}에 구독 일시정지가 해제됩니다.</p>
                                <p>{subscriptionRenewalDateView}에 구독료가 결제됩니다.</p>
                            </div>
                            <div>
                                <span>
                                    구독이 일시 정지되는 동안에는 구독료가 결제되지 않으며 서비스를 이용할 수 없습니다.<br />
                                    구독 일시 정지가 해제되면 구독료가 결제됩니다.<br />
                                    구독 일시 정지가 해제되기 3일전 이메일을 보내 알려드리며 일시 정지 기간 만료 전에도 언제든지 일시 정지를 해제하거나 구독을 취소할 수 있습니다.
                                </span>
                            </div>
                            <div className={styles.actionButtonWrapper}>
                                <InnocodeButton size={"xl"} className={styles.actionButton} onClick={handleConfirm}>구독 일시 정지</InnocodeButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};